import { get } from '@/helpers/httpHandler';
import { cloneDeep } from 'lodash';

export default {
  getItemsList({ commit }, { params } = {}) {
    return get(`/employees`, {
      ...params.filters,
      ...params.paginationOptions
    }).then(response => {
      commit('setFilters', cloneDeep(params.filters));
      commit('setPaginationOptions', cloneDeep(params.paginationOptions));
      return response;
    });
  },

  getEmployeeSkills() {
    return get('/employee-skills');
  },

  getEmployeeStatuses(_, params) {
    return get('/filters/employees/statuses', params);
  },

  getEmployeeTypes(_, params) {
    return get('/employees/types', params);
  }
};
